import { jsx as _jsx } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
const LoadingSpinner = ({ containerStyles, spinnerStyles, spinnerSize }) => {
    const circularProgressStyles = { ...spinnerStyles, color: '#00677F' };
    return (_jsx(Box, { sx: containerStyles, children: _jsx(CircularProgress, { sx: circularProgressStyles, size: spinnerSize }) }));
};
export default LoadingSpinner;
